import { useEffect, useState } from 'react'
import PageHeader from '../../../../components/Layout/Header/PageHeader'

import MySaathiLogo from '../../../../assets/images/sema-onboarding/mysaathi-logo.webp'
import PhoneScreen from './PhoneScreen'
import OTPScreen from './OTPScreen'
import { showErrorToast } from '../../../../utils/toast'
import constants from '../../../../constants'
import {
  MYSAATHI_VARIANT_STORAGE_KEY,
  QR_TYPES,
  SEMAGLYN,
} from '../../../../constants/sema-constants'
import * as actions from '../../../../store/slices'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getUrlParams } from '../../../../utils/helpers/common'
import { trackEvent } from '../../../../analytics'
import { EVENTS } from '../../../../analytics/events'

const OTP_RESEND_TIME = 30

const RegisterPage = () => {
  const { variant } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = getUrlParams()

  const {
    sendOtp: {
      loading: sendOtpLoading,
      error: sendOtpError,
      data: sendOtpData,
    },
    asignGLPPlanState: {
      loading: asignGLPPlanLoading,
      success: asignGLPPlanSuccess,
      error: asignGLPPlanError,
      data: asignGLPPlanData,
    },
  } = useSelector((state) => state.auth)

  const [activeScreen, setActiveScreen] = useState('phone')
  const [timer, setTimer] = useState(OTP_RESEND_TIME)
  const [formObject, setFormObject] = useState({
    name: '',
    contactNo: '',
  })
  const updateFormObject = (key, value) => {
    setFormObject({ ...formObject, [key]: value })
  }

  // console.log('sendOtpData', { sendOtpLoading, sendOtpError, sendOtpData })

  // Timer for OTP resend
  useEffect(() => {
    let intervalRef = null
    //Implementing the setInterval method
    if (activeScreen === 'otp') {
      intervalRef = setInterval(() => {
        if (timer > 0) setTimer(timer - 1)
      }, 1000)
    }

    //Clearing the interval
    return () => clearInterval(intervalRef)
  }, [timer, activeScreen])
  // Step: Send OTP
  const handleSendOtp = () => {
    localStorage.removeItem('auth_token')
    localStorage.setItem('phone_number', formObject.contactNo)
    if (formObject.contactNo.length === 10) {
      const payload = {
        payload: {
          contactNo: formObject.contactNo,
          otpType: 'LOGIN',
        },
        headers: {
          userFrom: constants.GLP_USER_FROM,
          source: constants.GOOD_FLIP_SOURCE,
        },
      }

      // For CGM flow, add minimal metadata
      payload.payload.meta = {
        support_program_type: variant?.toUpperCase(),
        qrType: params?.doctor_id ? QR_TYPES.DOCTOR : QR_TYPES.MEDICINE,
      }

      // dispatch(actions.sendOtpRequestV2(payload))
      new Promise((resolve, reject) => {
        dispatch(
          actions.sendOtpRequest({
            payload,
            resolve,
            reject,
          }),
        )
      })
        .then((response) => {
          if (Number(response?.code || 0) === 1) {
            setActiveScreen('otp')
            setTimer(OTP_RESEND_TIME)
            trackEvent(EVENTS.OTP_RECEIVED, {
              screenName: 'Onboarding_Screen',
              ...formObject,
            })
          } else {
            showErrorToast(response?.message)
          }
        })
        .catch((error) => {
          showErrorToast(error?.message)
        })
    }
  }

  // Handle Verify OTP
  const handleVerifyOtp = (otp) => {
    const payload = {
      payload: {
        contactNo: formObject.contactNo,
        name: formObject.name,
        otpType: 'LOGIN',
        otp: Number(otp),
        patient_meta_info: {
          support_program_type: variant.toUpperCase(),
        },
      },
      headers: {
        userFrom: constants.GLP_USER_FROM,
        source: constants.GOOD_FLIP_SOURCE,
      },
    }

    new Promise((resolve, reject) => {
      dispatch(
        actions.verifyOtpRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
      .then(async (res) => {
        if (Number(res?.code || 0) === 1) {
          localStorage.setItem('auth_token', res?.data?.token)
          handleAssignGLPPlan()
        } else {
          showErrorToast(res?.message)
        }
      })
      .catch((error) => {
        showErrorToast(error?.message)
      })
  }

  useEffect(() => {
    if (!asignGLPPlanSuccess || asignGLPPlanLoading || asignGLPPlanError) return
    let path = '/success'
    if (asignGLPPlanData?.isSemaUser) {
      path = `/blocked?support_program_name=${constants.GLP_USER_FROM.toLowerCase()}`
    } else if (asignGLPPlanData?.isPaidUser) {
      path = `/blocked?support_program_name=${constants.GOOD_FLIP_SOURCE.toLowerCase()}`
    }

    navigate(`/${variant || SEMAGLYN}${path}`)
  }, [
    asignGLPPlanSuccess,
    asignGLPPlanLoading,
    asignGLPPlanError,
    asignGLPPlanData,
    variant,
  ])

  const handleAssignGLPPlan = () => {
    trackEvent(EVENTS.OTP_VERIFIED, {
      screenName: 'Onboarding_Screen',
      ...formObject,
    })
    const selectedVariant =
      params?.mysaathi_variant ||
      localStorage.getItem(MYSAATHI_VARIANT_STORAGE_KEY)

    const payload = {
      variant: selectedVariant,
      doctorId: params?.doctor_id,
    }
    // TODO: need to update the header
    dispatch(actions.asignGLPPlanRequest(payload))
  }

  // Render Screen based on the active screen
  const renderScreen = () => {
    switch (activeScreen) {
      case 'phone':
        return (
          <PhoneScreen
            formObject={formObject}
            updateFormObject={updateFormObject}
            handleOnSubmit={handleSendOtp}
            isLoading={sendOtpLoading || asignGLPPlanLoading}
          />
        )
      case 'otp':
        return (
          <OTPScreen
            handleVerifyOtp={handleVerifyOtp}
            handleEditClick={() => setActiveScreen('phone')}
            handleResendOtp={handleSendOtp}
            formObject={formObject}
            isLoading={asignGLPPlanLoading}
            timer={timer}
          />
        )
      default:
        null
    }
  }
  return (
    <div>
      {/* Initial Step: Login/Register section */}
      <div className="min-w-sm max-w-lg pb-[98px] relative mx-auto w-full overflow-hidden">
        <PageHeader
          handleOnBack={() => navigate(-1)}
          pageTitle="Back"
          withBackBtn={true}
          rightImage={MySaathiLogo}
          rightImageClassName="w-24 object-scale-down"
        />
        <div className={`z-10 px-5 pt-6`}>{renderScreen()}</div>
      </div>
    </div>
  )
}

export default RegisterPage
